module.exports = __webpack_public_path__ + "static/media/27.9be2508d.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/pants/27.png
// module id = 880
// module chunks = 0